export default __webpack_public_path__ + "static/media/dfyn.c7d9f9d2.png";